import type { BadgeDef, Level } from '../types'

export const levels: Level[] = [
  { level: 1, key: 'level.1', xp: 0 },
  { level: 2, key: 'level.2', xp: 60 },
  { level: 3, key: 'level.3', xp: 120 },
  { level: 4, key: 'level.4', xp: 200 },
  { level: 5, key: 'level.5', xp: 300 },
]

export const badges: BadgeDef[] = [
  { id: 'badge.first', days: 1 },
  { id: 'badge.focus', days: 3 },
  { id: 'badge.week', days: 7 },
  { id: 'badge.unstoppable', days: 14 },
  { id: 'badge.legend', days: 30 },
]

/** Discipline Built: 21+ consecutive days scoring 70 points or more. */
export const DISCIPLINE_DAYS = 21
export const DISCIPLINE_MIN_SCORE = 70
